import { render, staticRenderFns } from "./OrderDetailNew.vue?vue&type=template&id=0e8e3efa&scoped=true"
import script from "./OrderDetailNew.vue?vue&type=script&lang=js"
export * from "./OrderDetailNew.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailNew.vue?vue&type=style&index=0&id=0e8e3efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e3efa",
  null
  
)

export default component.exports